/* global Sys, Core, Services */
Sys.ns("Core");

/**
 * The Auto Play model.
 *
 * @class Core.AutoPlayerModel
 * @extends Core.Model
 */
Core.AutoPlayerModel = {

    constructor: function() {
        Core.AutoPlayerModel.superclass.constructor.apply(this, arguments);
    },

    /**
     * @protected
     * @inheritdoc
     */
    setupData: function() {
        this.storeData("nrRounds", 0);
        this.storeData("spinning", true);
        this.storeData("startingBalance", 0);
        this.storeData("stopAutoplayIfBalanceIncreasedBy", false);
        this.storeData("stopAutoplayIfBalanceDecreasedBy", false);
        this.storeData("stopAutoplayOnAnyWin", false);
        this.storeData("stopAutoplayIfWinExceeds", false);
        this.setState("STOPPED");
    },

    /**
     * Play a round.
     *
     * @returns {void}
     */
    playRound: function() {
        var availableRounds = this.readData("nrRounds") - 1;

        if (availableRounds <= 0) {
            availableRounds = 0;
            this.setState("STOPPING");
        }

        this.storeData("nrRounds", availableRounds);
    },

    /**
     * @protected
     * @inheritdoc
     * @param {string} key The key.
     * @param {*} value The value.
     */
    storeData: function(key, value) {
        Core.AutoPlayerModel.superclass.storeData.apply(this, arguments);
        if (key === "nrRounds") {
            Services.storage.storeData("autoPlayer.roundsLeft", value);
        }
    },

    /**
     * Check if another round should be played.
     *
     * @returns {boolean} Whether or not another round should be played.
     */
    shouldPlayAnotherRound: function() {
        return this.isState("PLAYING");
    },

    /**
     * Checks server response whether auto play should stop or not.
     *
     * @protected
     * @param {Object} serverResponse Parsed server response.
     * @returns {boolean} Should auto play stop or not.
     */
    shouldStopAutoplay: function(serverResponse) {
        var startingBalance = this.readData("startingBalance"),
            stopIfWon = this.readData("stopAutoplayIfBalanceIncreasedBy"),
            stopIfLost = this.readData("stopAutoplayIfBalanceDecreasedBy"),
            stopOnAnyWin = this.readData("stopAutoplayOnAnyWin"),
            stopIfWinExceeds = this.readData("stopAutoplayIfWinExceeds"),
            bet = serverResponse.nextaction === "spin" ? Services.moneyManager.getBetCents() : 0,
            win,
            totalWin;

        if (Sys.isObj(serverResponse.wins)) {
            win = serverResponse.wins.cents;
            totalWin = serverResponse.wins.centsTotal;
        }

        if (stopIfWon && serverResponse.credit >= (startingBalance + stopIfWon)) {
            return true;
        }

        if (stopIfLost && (serverResponse.credit - bet) < (startingBalance - stopIfLost)) {
            return true;
        }

        if (stopOnAnyWin === true && (win > 0 || totalWin > 0)) {
            return true;
        }

        return stopIfWinExceeds && (win >= stopIfWinExceeds || totalWin >= stopIfWinExceeds);
    },

    /**
     * Parses the server response for balance and win information to see if the autoplay should be aborted or not.
     *
     * @param {Object} serverResponse The parsed server response.
     * @returns {void}
     */
    processServerResponse: function(serverResponse) {
        var gameState = serverResponse.gamestate || {};

        if (!this.isState("STOPPED") && this.shouldStopAutoplay(serverResponse)) {
            this.setState("STOPPING");
        }

        this.storeData("isBasicState", gameState.current === "basic");
    }
};

Core.AutoPlayerModel = Sys.extend(Core.Model, Core.AutoPlayerModel, "Core.AutoPlayerModel");
